import { render, staticRenderFns } from "./ot-due-date-tag.vue?vue&type=template&id=52021d06&scoped=true&"
import script from "./ot-due-date-tag.vue?vue&type=script&lang=ts&"
export * from "./ot-due-date-tag.vue?vue&type=script&lang=ts&"
import style0 from "./ot-due-date-tag.vue?vue&type=style&index=0&id=52021d06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52021d06",
  null
  
)

export default component.exports